/** Oblast centers for nearest-region lookup (UA coords). */
const UKRAINE_REGION_CENTERS = [
  { nameUa: 'Київ', nameRu: 'Киев', nameEn: 'Kyiv', lat: 50.4501, lng: 30.5234 },
  { nameUa: 'Київська область', nameRu: 'Киевская область', nameEn: 'Kyiv Oblast', lat: 50.45, lng: 30.75 },
  { nameUa: 'Харківська область', nameRu: 'Харьковская область', nameEn: 'Kharkiv Oblast', lat: 49.9935, lng: 36.2304 },
  { nameUa: 'Одеська область', nameRu: 'Одесская область', nameEn: 'Odesa Oblast', lat: 46.4825, lng: 30.7233 },
  {
    nameUa: 'Дніпропетровська область',
    nameRu: 'Днепропетровская область',
    nameEn: 'Dnipropetrovsk Oblast',
    lat: 48.4647,
    lng: 35.0462,
  },
  { nameUa: 'Донецька область', nameRu: 'Донецкая область', nameEn: 'Donetsk Oblast', lat: 48.0159, lng: 37.8028 },
  {
    nameUa: 'Запорізька область',
    nameRu: 'Запорийская область',
    nameEn: 'Zaporizhzhia Oblast',
    lat: 47.8388,
    lng: 35.1396,
  },
  { nameUa: 'Львівська область', nameRu: 'Львовская область', nameEn: 'Lviv Oblast', lat: 49.8397, lng: 24.0297 },
  { nameUa: 'Полтавська область', nameRu: 'Полтавская область', nameEn: 'Poltava Oblast', lat: 49.5883, lng: 34.5514 },
  { nameUa: 'Вінницька область', nameRu: 'Винницкая область', nameEn: 'Vinnytsia Oblast', lat: 49.2331, lng: 28.4682 },
  { nameUa: 'Сумська область', nameRu: 'Сумская область', nameEn: 'Sumy Oblast', lat: 50.9077, lng: 34.7981 },
  { nameUa: 'Черкаська область', nameRu: 'Черкасская область', nameEn: 'Cherkasy Oblast', lat: 49.4444, lng: 32.0598 },
  {
    nameUa: 'Кіровоградська область',
    nameRu: 'Кировоградская область',
    nameEn: 'Kirovohrad Oblast',
    lat: 48.5079,
    lng: 32.2623,
  },
  {
    nameUa: 'Миколаївська область',
    nameRu: 'Николаевская область',
    nameEn: 'Mykolaiv Oblast',
    lat: 46.975,
    lng: 31.9946,
  },
  { nameUa: 'Херсонська область', nameRu: 'Херсонская область', nameEn: 'Kherson Oblast', lat: 46.6354, lng: 32.6178 },
  {
    nameUa: 'Чернігівська область',
    nameRu: 'Черниговская область',
    nameEn: 'Chernihiv Oblast',
    lat: 51.4982,
    lng: 31.2893,
  },
  {
    nameUa: 'Житомирська область',
    nameRu: 'Житомирская область',
    nameEn: 'Zhytomyr Oblast',
    lat: 50.2546,
    lng: 28.6587,
  },
  { nameUa: 'Рівненська область', nameRu: 'Ровенская область', nameEn: 'Rivne Oblast', lat: 50.6199, lng: 26.2516 },
  { nameUa: 'Волинська область', nameRu: 'Волынская область', nameEn: 'Volyn Oblast', lat: 50.7472, lng: 25.3253 },
  {
    nameUa: 'Тернопільська область',
    nameRu: 'Тернопольская область',
    nameEn: 'Ternopil Oblast',
    lat: 49.5535,
    lng: 25.5948,
  },
  {
    nameUa: 'Івано-Франківська область',
    nameRu: 'Ивано-Франковская область',
    nameEn: 'Ivano-Frankivsk Oblast',
    lat: 48.9226,
    lng: 24.7111,
  },
  {
    nameUa: 'Закарпатська область',
    nameRu: 'Закарпатская область',
    nameEn: 'Zakarpattia Oblast',
    lat: 48.6208,
    lng: 22.2879,
  },
  {
    nameUa: 'Чернівецька область',
    nameRu: 'Черновицкая область',
    nameEn: 'Chernivtsi Oblast',
    lat: 48.2915,
    lng: 25.9404,
  },
  {
    nameUa: 'Хмельницька область',
    nameRu: 'Хмельницкая область',
    nameEn: 'Khmelnytskyi Oblast',
    lat: 49.4229,
    lng: 26.9871,
  },
  { nameUa: 'Луганська область', nameRu: 'Луганская область', nameEn: 'Luhansk Oblast', lat: 48.574, lng: 39.3078 },
  {
    nameUa: 'Автономна Республіка Крим',
    nameRu: 'Автономная Республика Крым',
    nameEn: 'Autonomous Republic of Crimea',
    lat: 45.3453,
    lng: 34.4997,
  },
];

const LAT_MIN = 44.2;
const LAT_MAX = 52.6;
const LNG_MIN = 22;
const LNG_MAX = 40.4;

export function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** Map WGS84 to percent position inside the wiki-style Ukraine mini map SVG. */
export function latLonToUkraineMapPercent(latitude, longitude) {
  const lat = Number(latitude);
  const lon = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return null;
  }
  const x = ((lon - LNG_MIN) / (LNG_MAX - LNG_MIN)) * 100;
  const y = ((LAT_MAX - lat) / (LAT_MAX - LAT_MIN)) * 100;
  return {
    x: Math.min(94, Math.max(6, x)),
    y: Math.min(94, Math.max(6, y)),
  };
}

/** Nearest oblast / city label for coordinates. */
export function findUkraineRegionName(latitude, longitude, lang = 'ua') {
  const lat = Number(latitude);
  const lon = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return null;
  }

  let best = UKRAINE_REGION_CENTERS[0];
  let bestDist = Infinity;
  for (const region of UKRAINE_REGION_CENTERS) {
    const d = haversineKm(lat, lon, region.lat, region.lng);
    if (d < bestDist) {
      bestDist = d;
      best = region;
    }
  }

  if (lang === 'ru') {
    return best.nameRu;
  }
  if (lang === 'en') {
    return best.nameEn;
  }
  return best.nameUa;
}

/**
 * Approximate distance (km) outside Ukraine.
 * Returns 0 when coordinates fall inside the country bounding box.
 */
export function distanceKmOutsideUkraine(latitude, longitude) {
  const lat = Number(latitude);
  const lon = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return null;
  }

  if (lat >= LAT_MIN && lat <= LAT_MAX && lon >= LNG_MIN && lon <= LNG_MAX) {
    return 0;
  }

  let bestDist = Infinity;
  for (const region of UKRAINE_REGION_CENTERS) {
    const d = haversineKm(lat, lon, region.lat, region.lng);
    if (d < bestDist) {
      bestDist = d;
    }
  }
  return bestDist;
}

/** True when GPS is farther than {@code thresholdKm} from Ukraine. */
export function isGpsFarFromUkraine(latitude, longitude, thresholdKm = 3000) {
  const distanceKm = distanceKmOutsideUkraine(latitude, longitude);
  return distanceKm != null && distanceKm > thresholdKm;
}

/** True when a segment looks like an oblast / region name. */
function looksLikeRegionPart(part) {
  if (!part) return false;
  const lower = part.toLowerCase();
  return (
    lower.includes('область') ||
    lower.includes('oblast') ||
    /\bобл\.?\b/i.test(part) ||
    lower.includes('край') ||
    lower.includes('республік') ||
    lower.includes('республик')
  );
}

/**
 * Full station.address for UI labels (POI, City, Region).
 * Returns null when empty so callers can fall back to geocode-by-coords.
 */
export function stationAddressLabel(address) {
  if (!address || typeof address !== 'string') {
    return null;
  }
  const trimmed = address.trim();
  return trimmed || null;
}

/**
 * City hint from station address.
 * New format "POI, City, Region": when last part looks like a region and there
 * are 3+ parts, use the second-to-last. Otherwise use the first part (legacy).
 */
export function cityFromStationAddress(address) {
  if (!address || typeof address !== 'string') {
    return null;
  }
  const parts = address
    .split(',')
    .map(p => p.trim())
    .filter(Boolean);
  if (!parts.length) {
    return null;
  }
  if (parts.length >= 3 && looksLikeRegionPart(parts[parts.length - 1])) {
    return parts[parts.length - 2] || null;
  }
  return parts[0] || null;
}
